// extracted by mini-css-extract-plugin
module.exports = {"container":"Education_container__2h-ld","infoBlock":"Education_infoBlock__2LWCt","carousel":"Education_carousel__2dFGT","list":"Education_list__QwHrw"};